// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import VueSweetalert2 from 'vue-sweetalert2'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import UUID from 'vue-uuid';
import '../static/css/theme-chalk/index.css'

//quill editor import part
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// firebase import part
import VueFire from 'vuefire'
import '../static/images/icons/favicon.png'
import '../static/vendor/bootstrap/css/bootstrap.min.css'
import '../static/fonts/font-awesome-4.7.0/css/font-awesome.min.css'
import '../static/fonts/themify/themify-icons.css'
import '../static/vendor/animate/animate.css'
import '../static/vendor/css-hamburgers/hamburgers.min.css'
import '../static/vendor/animsition/css/animsition.min.css'
import '../static/vendor/select2/select2.min.css'
import '../static/vendor/daterangepicker/daterangepicker.css'
import '../static/vendor/slick/slick.css'
import '../static/vendor/lightbox2/css/lightbox.min.css'
import '../static/css/util.css'
import '../static/css/main.css'
import '../static/lib/bootstrap/css/bootstrap.css'
//import '../static/lib/css/main.css'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// this part resolve an issue where the markers would not appear
// import * as firebase from 'firebase' //Dev mode
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
let firebaseConfig = {
    apiKey: "AIzaSyCY5dX3YQ2H60dmnK6ru4HS64nPEkOWOpQ",
    authDomain: "keelungwebsite.firebaseapp.com",
    databaseURL: "https://keelungwebsite.firebaseio.com/",
    projectId: "keelungwebsite",
    storageBucket: "keelungwebsite.appspot.com",
    messagingSenderId: "1031994154752"
};

var firebaseApp = firebase.initializeApp(firebaseConfig);
window.firebase = firebase;
window.firebaseDB = firebaseApp.database();
window.firebaseSG = firebaseApp.storage();
window.firebaseAuth = firebase.auth();
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const options = {
    position: 'top-end',
    type: 'success',
    title: 'Your work has been saved',
    showConfirmButton: false,
    timer: 1500
}
Vue.prototype.$ajax = axios;
Vue.use(VueSweetalert2, options)
Vue.use(VueI18n)
Vue.use(ElementUI, { locale })
Vue.use(VueAxios, axios)
Vue.use(UUID);
Vue.use(VueQuillEditor);
Vue.axios = axios
Vue.config.productionTip = false

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: navigator.language, // set locale
    fallbackLocale: 'en-US',
    messages: {
        'zh-TW': require('../static/lang/zh'),
        'en-US': require('../static/lang/en'),
        'de': require('../static/lang/de'),
        'fr': require('../static/lang/fr'),
        'ja': require('../static/lang/ja'),
        'th': require('../static/lang/th')
    }
});
Vue.use(VueFire)
//跳轉回頂部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
    if (document.getElementById("banner") != null) {
        document.getElementById("banner").src = "/static/images/icons/logo.png";
    }
})
new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js